import React from 'react';
import { getVersion } from '../../utils/utils';
import { X_URL } from "../../utils/constants";

function SystemInfo() {
  const currentYear = new Date().getFullYear();
  const currentEnv = process.env.REACT_APP_CHAT_API_ENV || 'production';

  const renderVersion = () => {
    return (
      <a href={X_URL} target="_blank" rel="noopener noreferrer">
        <p><span className="version">v{getVersion()}</span></p>
      </a>
    );
  };

  const renderEnvironment = () => {
    if (currentEnv !== 'production') {
      return <p><span className="environment">{currentEnv.toUpperCase()}</span></p>;
    }
    return null;
  };

  const renderCopyright = () => {
    return <p><span className="copyright">©</span> {currentYear} Syntactic Sgr</p>;
  };

  return (
    <div className="system-info-container">
      <div className="system-info">
        {renderEnvironment()}
        {renderVersion()}
        {renderCopyright()}
      </div>
    </div>
  );
}

export default SystemInfo;
